/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* EFS snapshot properties for native AWS Backup snapshots.
*/
export class EfsSnapshotProperties {
  /**
  * AWS Backup recovery point ARN.
  */
  'recoveryPointArn'?: string;
  /**
  * AWS Backup vault name where the backup is stored.
  */
  'backupVaultName'?: string;
  /**
  * AWS region where the backup is stored.
  */
  'region'?: string;
  /**
  * AWS account ID where the backup is stored.
  */
  'sourceAccountId'?: string;
  /**
  * Performance mode of the source EFS at backup time.
  */
  'performanceMode'?: EfsSnapshotPropertiesPerformanceModeEnum;
  /**
  * Throughput mode of the source EFS at backup time.
  */
  'throughputMode'?: EfsSnapshotPropertiesThroughputModeEnum;
  /**
  * Provisioned throughput in MiB/s (when throughputMode was provisioned).
  */
  'provisionedThroughputMibps'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "recoveryPointArn",
      "baseName": "recoveryPointArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "backupVaultName",
      "baseName": "backupVaultName",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceAccountId",
      "baseName": "sourceAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "performanceMode",
      "baseName": "performanceMode",
      "type": "EfsSnapshotPropertiesPerformanceModeEnum",
      "format": ""
    },
    {
      "name": "throughputMode",
      "baseName": "throughputMode",
      "type": "EfsSnapshotPropertiesThroughputModeEnum",
      "format": ""
    },
    {
      "name": "provisionedThroughputMibps",
      "baseName": "provisionedThroughputMibps",
      "type": "number",
      "format": "double"
    }  ];

  static getAttributeTypeMap() {
    return EfsSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum EfsSnapshotPropertiesPerformanceModeEnum {
  GeneralPurpose = 'generalPurpose',
  MaxIo = 'maxIO'
}
export enum EfsSnapshotPropertiesThroughputModeEnum {
  Bursting = 'bursting',
  Provisioned = 'provisioned',
  Elastic = 'elastic'
}

